// import request from '@/modules/request'
import { $t } from '@/modules/i18n';

const getRegionRenderName = (cityTransifyKey, cityDefaultName, regionTransifyKey, regionDefaultName, cityCount) => {
  const cityTransifyText = $t(cityTransifyKey);
  const regionTransifyText = $t(regionTransifyKey);
  const isCityWithoutTransify = cityTransifyText === cityTransifyKey;
  const isRegionWithoutTransify = regionTransifyText === regionTransifyKey;
  let renderText = '';
  if (isCityWithoutTransify && isRegionWithoutTransify) {
    if (cityCount === 1 && regionDefaultName === cityDefaultName) {
      renderText = regionDefaultName || '';
    } else {
      renderText = `${regionDefaultName || ''} - ${cityDefaultName || ''}`;
    }
  } else if (!isCityWithoutTransify && isRegionWithoutTransify) {
    if (cityCount === 1 && regionDefaultName === cityTransifyText) {
      renderText = regionDefaultName || '';
    } else {
      renderText = `${regionDefaultName || ''} - ${cityTransifyText}`;
    }
  } else if (isCityWithoutTransify && !isRegionWithoutTransify) {
    if (cityCount === 1 && regionTransifyText === cityDefaultName) {
      renderText = cityDefaultName || '';
    } else {
      renderText = `${regionTransifyText} - ${cityDefaultName || ''}`;
    }
  } else if (cityTransifyText === regionTransifyText) {
    renderText = cityCount === 1 ? cityTransifyText : `${regionTransifyText} - ${cityTransifyText}`;
  } else {
    renderText = `${regionTransifyText} - ${cityTransifyText}`;
  }
  return renderText;
};

function initBaseUrl() {
  const COUNTRY = process.env.REACT_APP_COUNTRY || 'sg';
  const ENV = process.env.REACT_APP_ENV || 'test';
  let baseUrl = `https://careers.shopee.${COUNTRY}`;
  if(ENV !== 'live') {
    if(COUNTRY === 'id' || COUNTRY === 'th') {
      baseUrl = `https://careers.${ENV}.shopee.co.${COUNTRY}`;
    } else if(COUNTRY === 'br' || COUNTRY === 'my') {
      baseUrl = `https://careers.${ENV}.shopee.com.${COUNTRY}`;
    }
    else {
      baseUrl = `https://careers.${ENV}.shopee.${COUNTRY}`;
    }
  } else {
    if(COUNTRY === 'id' || COUNTRY === 'th') {
      baseUrl = `https://careers.shopee.co.${COUNTRY}`;
    } else if(COUNTRY === 'br' || COUNTRY === 'my') {
      baseUrl = `https://careers.shopee.com.${COUNTRY}`;
    }
    else {
      baseUrl = `https://careers.shopee.${COUNTRY}`;
    }
  }
  return baseUrl;
}

function initATSBaseUrl() {
  const ENV = process.env.REACT_APP_ENV || 'test';
  if(ENV === 'live') {
    return `https://ats.workatsea.com/ats/api/v1`
  } else if(ENV === 'liveish') {
    return 'https://ats.live-test.workatsea.com/ats/api/v1'
  }
  return `https://ats.${ENV}.workatsea.com/ats/api/v1`
}

function handlePartner(partnerTypeList, column) {
  const partnerData = []
  const col = Math.floor(12 / column)
  partnerTypeList.forEach(partnerType => {
    const logos = partnerType.partner_list.map(item => {
      return {
        // image: item.image_id ? `https://cf.shopee.sg/file/${item.image_id}_256` : '',
        image: item.image_id ? `https://img.sp.mms.shopee.sg/file/${item.image_id}` : '',
        name: item.transify_key,
        defaultName: item.title,
        link: item.redirect_url,
        col
      }
    })
    partnerData.push({
      title: partnerType.transify_key,
      defaultTitle: partnerType.title,
      justifyCenter: partnerType.justify_center,
      logos
    })
  })
  return partnerData
}

export function getPartnerDataRequest(id) {
  return request(`/user/activity/partner/list/?activity_id=${id}`).then(res => {
    const data = res.data
    if(data) {
      return handlePartner(data.partner_types, data.activity.web_col_num)
    }
    return [];
  })
}

export async function getMeta() {
  try {
    const { data } = await request('/user/meta/slice/', 'GET', {
      flags: 367472,
      from_career: true
    }, null, true);
    const { 
      employment_level_list, 
      flat_locations,
      dept_list 
    } = data;

    const locationList = flat_locations.map(item => {
      return {
        ...item,
        text: getRegionRenderName(item.city_transify_key, item.city_name, item.region_transify_key, item.region_name, item.cityCount),
        value: item.career_value_city
      }
    });

    const levelList = employment_level_list.map(item => {
      let text = $t(item.transify_key);
      if (text === item.transify_key) {
        text = item.default_text;
      }

      return {
        text,
        value: item.career_value,
        ...item
      }
    });

    const deptList = dept_list.map(item => {
      let text = $t(item.name_transify_key);
      if (text === item.name_transify_key) {
        text = item.dept_name;
      }

      return {
        text,
        value: item.career_value,
        ...item
      }
    });

    return {
      locationList,
      levelList,
      deptList
    }
    
  } catch(e) {
    console.error(e);
  }
}

export async function postSubscription(data) {
  try {
    const res = await request('/user/subscription/', 'POST', data);
    return res;
  } catch(e) {
    console.error(e);
  }
}

export default function request(url, method, data, headers, isATS = false) {
  method = method || 'GET';
  data = data || null
  
  let baseUrl = window.location.origin + '/api';
  if (isATS) {
    baseUrl = initATSBaseUrl();
  }
  if (!url) return '未输入url';
  const body = method === 'POST' && data;
  let paramsStr = '';
  const params = {
    mode: 'cors',
    method,
    headers: headers || {},
    credentials: 'include'
  }

  if(method === 'GET' && data !== null) {
    paramsStr = `?`;
    Object.keys(data).forEach(item => {
      paramsStr += `${item}=${data[item]}&`;
    })
  }

  if (body) {
    params.body = JSON.stringify(data);
    params.headers['Content-Type'] = params.headers['Content-Type'] || 'application/json';
  }
  const realUrl = baseUrl + url + paramsStr;
  return new Promise((resolve, reject) => {
    fetch(realUrl, params).then(res => {
      if(res.status === 200) {
        res.json().then(json => {
          resolve(json);
        })
      } else {
        console.error('fetch fail');
      }
    }).catch(err => {
      reject(err);
    })
  })
}